import { BlokItem, DynamicRender, sbEditable, SBProps } from '../../../utils';
import { Header } from './components/Header';

interface SBHeaderProps {
  body?: BlokItem[];
  preHeader?: BlokItem[];
}

export const SBHeader = ({ blok }: SBProps<SBHeaderProps>) => {
  const { body } = blok;

  return (
    <Header className="sticky top-0 z-50 w-full bg-white" {...sbEditable(blok)}>
      <DynamicRender data={body} />
    </Header>
  );
};
